import React from 'react';
import MeetingCard from './MeetingCard';

const MeetingList = ({ meetings }) => {
  const groupMeetingsByMonth = (meetings) => {
    const grouped = {};
    
    meetings.forEach(meeting => {
      const date = new Date(meeting.date);
      const monthKey = date.toLocaleDateString('sv-SE', { 
        year: 'numeric', 
        month: 'long' 
      });
      
      if (!grouped[monthKey]) {
        grouped[monthKey] = [];
      }
      
      grouped[monthKey].push(meeting);
    });
    
    // Sort meetings within each month
    Object.keys(grouped).forEach(month => {
      grouped[month].sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        
        if (dateA.getTime() !== dateB.getTime()) {
          return dateA.getTime() - dateB.getTime();
        }
        
        // If same date, sort by time
        if (a.time === '-' && b.time !== '-') return 1;
        if (a.time !== '-' && b.time === '-') return -1;
        return a.time.localeCompare(b.time);
      });
    });
    
    return grouped;
  };

  const monthOrder = [
    'augusti 2025',
    'september 2025', 
    'oktober 2025',
    'november 2025',
    'december 2025'
  ];

  const groupedMeetings = groupMeetingsByMonth(meetings);
  const sortedMonths = monthOrder.filter(month => 
    Object.keys(groupedMeetings).some(key => 
      key.toLowerCase() === month.toLowerCase()
    )
  );

  if (meetings.length === 0) {
    return (
      <div className="meeting-list-empty">
        <div className="empty-state">
          <h3>Inga möten hittades</h3>
          <p>Prova att ändra dina filter för att se fler möten.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="meeting-list">
      {sortedMonths.map(monthKey => {
        const actualKey = Object.keys(groupedMeetings).find(key => 
          key.toLowerCase() === monthKey.toLowerCase()
        );
        
        if (!actualKey) return null;
        
        const monthMeetings = groupedMeetings[actualKey];
        
        return (
          <div key={monthKey} className="month-section">
            <div className="month-header">
              <h2 className="month-title">
                {actualKey.charAt(0).toUpperCase() + actualKey.slice(1)}
              </h2>
              <span className="month-count">
                {monthMeetings.length} möten
              </span>
            </div>
            
            <div className="month-meetings">
              {monthMeetings.map((meeting, index) => (
                <MeetingCard 
                  key={meeting.id || `${meeting.date}-${meeting.lodge}-${meeting.region || 'bardaland'}-${meeting.time}-${index}`} 
                  meeting={meeting} 
                />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MeetingList;